// URL Helper
function getComicFromURL() {
  const params = new URLSearchParams(window.location.search);
  return params.get('comic'); // "01", "02", etc
}

// lazy load images
const imageObserver = new IntersectionObserver(
  entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const img = entry.target;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      imageObserver.unobserve(img);
    });
  },
  {
    rootMargin: '300px', // preload before visible
  },
);

// preload next comic
const preloadedComics = new Set();

function preloadNextComic(comicId) {
  const next = Number(comicId) + 1;
  if (next > LAST_COMIC) return;

  const nextId = String(next).padStart(2, '0');
  if (preloadedComics.has(nextId)) return;

  preloadedComics.add(nextId);

  fetch(`./img/comics/${nextId}/manifest.json`)
    .then(r => r.json())
    .then(() => {
      const img = new Image();
      img.src = `./img/comics/${nextId}/001.webp`;
    })
    .catch(() => {});
}

// scroll helper
function scrollToComicReader() {
  const reader = document.querySelector('.nav');
  if (!reader) return;

  const rect = reader.getBoundingClientRect();
  if (rect.top > -50 && rect.top < 50) return;

  window.scrollTo({
    top: rect.top + window.pageYOffset - 16,
    behavior: 'smooth',
  });
}

// comic switching, area directly under the comics

const FIRST_COMIC = 1;
// UPDATE THIS LINE TO THE NUMBER OF COMICS
const LAST_COMIC = 5;

function navigateComic(comicNumber) {
  const comicId = String(comicNumber).padStart(2, '0');

  history.pushState({}, '', `?comic=${comicId}`);
  loadComic(comicId);
}

function updateSwitchNav(currentComicId) {
  const nextBtn = document.querySelector('.switch__next');
  const prevBtn = document.querySelector('.switch__prev');

  if (!nextBtn || !prevBtn) return;

  const current = Number(currentComicId);

  const prevComic = current - 1;
  const nextComic = current + 1;

  // ---- PREV ----
  if (current <= FIRST_COMIC) {
    prevBtn.classList.add('is-disabled');
    prevBtn.removeAttribute('href');
  } else {
    prevBtn.classList.remove('is-disabled');
    prevBtn.href = `?comic=${String(prevComic).padStart(2, '0')}`;
    prevBtn.onclick = e => {
      e.preventDefault();
      navigateComic(prevComic);
    };
  }

  // ---- NEXT ----
  if (current >= LAST_COMIC) {
    nextBtn.classList.add('is-disabled');
    nextBtn.removeAttribute('href');
  } else {
    nextBtn.classList.remove('is-disabled');
    nextBtn.href = `?comic=${String(nextComic).padStart(2, '0')}`;
    nextBtn.onclick = e => {
      e.preventDefault();
      navigateComic(nextComic);
    };
  }
}

// swipe hint
function toggleSwipeHint(totalPages) {
  const hint = document.getElementById('icon-swipe');
  if (!hint) return;

  if (totalPages < 3) {
    hint.style.display = 'none';
    hint.classList.remove('play');
    hint.style.opacity = '1';
    return;
  }

  // Show
  hint.style.display = 'block';
  hint.style.opacity = '1';

  // Restart animation
  hint.classList.remove('play');
  void hint.offsetWidth; // force reflow
  hint.classList.add('play');
}

// update nav text
function updateComicNav(manifest) {
  const chapterEl = document.querySelector('.nav__chapter');
  if (!chapterEl) return;

  if (manifest.title) {
    chapterEl.textContent = manifest.title;
  }
}

// Books List pager
let booksPager = null;

function renderBooksPage(page) {
  if (!booksPager) return;

  const { cards, pageButtons, prevBtn, nextBtn, totalPages } = booksPager;

  booksPager.currentPage = Math.max(1, Math.min(totalPages, page));

  cards.forEach(card => {
    card.style.display =
      Number(card.dataset.page) === booksPager.currentPage ? '' : 'none';
  });

  pageButtons.forEach(btn => {
    btn.classList.toggle(
      'books__page__active',
      Number(btn.dataset.page) === booksPager.currentPage,
    );
  });

  prevBtn.disabled = booksPager.currentPage <= 1;
  nextBtn.disabled = booksPager.currentPage >= totalPages;
}

// book list initializaiton
(() => {
  const section = document.querySelector('.books');
  if (!section) return;

  const cards = Array.from(section.querySelectorAll('.books__grid__card'));
  const pager = section.querySelector('.books__page');
  if (!pager) return;

  const pageButtons = Array.from(
    pager.querySelectorAll('.books__page__btn.page'),
  );
  const prevBtn = pager.querySelector('.books__page__btn.prev');
  const nextBtn = pager.querySelector('.books__page__btn.next');

  booksPager = {
    cards,
    pageButtons,
    prevBtn,
    nextBtn,
    totalPages: pageButtons.length,
    currentPage: 1,
  };

  pageButtons.forEach(btn =>
    btn.addEventListener('click', () =>
      renderBooksPage(Number(btn.dataset.page)),
    ),
  );

  prevBtn.addEventListener('click', () =>
    renderBooksPage(booksPager.currentPage - 1),
  );

  nextBtn.addEventListener('click', () =>
    renderBooksPage(booksPager.currentPage + 1),
  );

  renderBooksPage(1);
})();

// comic loading system

let comicSwiper = null;

// build swiper
function buildComicSwiper(comicId, totalPages) {
  const wrapper = document.querySelector('.comicSwiper .swiper-wrapper');
  wrapper.innerHTML = '';

  const swiperEl = document.querySelector('.comicSwiper');
  if (swiperEl) {
    swiperEl.style.minHeight = `${swiperEl.offsetHeight}px`;
    swiperEl.classList.add('is-loading');
  }

  for (let i = 1; i <= totalPages; i++) {
    const slide = document.createElement('div');
    slide.className = `swiper-slide ${
      i % 2 === 1 ? 'is-right-page' : 'is-left-page'
    }`;

    slide.innerHTML = `
      <figure class="pageFigure swiper-zoom-container">
        <img
          class="pageImg singleComic"
          data-src="./img/comics/${comicId}/${String(i).padStart(3, '0')}.webp"
          alt="Page ${i}"
        />
      </figure>
    `;

    wrapper.appendChild(slide);
  }

  if (totalPages > 1 && totalPages % 2 === 1) {
    wrapper.insertAdjacentHTML(
      'beforeend',
      `<div class="swiper-slide is-blank" aria-hidden="true">
        <figure class="pageFigure"></figure>
      </div>`,
    );
  }

  if (comicSwiper) comicSwiper.destroy(true, true);

  comicSwiper = new Swiper('.comicSwiper', {
    loop: false,
    watchOverflow: true,
    dir: 'rtl',
    slidesPerView: 2,
    slidesPerGroup: 2,
    autoHeight: false,

    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        centeredSlides: true,
        zoom: { maxRatio: 3 },
      },
      1200: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        centeredSlides: false,
        zoom: false,
      },
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    keyboard: { enabled: true },
  });

  const firstImg = wrapper.querySelector('img');
  if (firstImg && firstImg.dataset.src) {
    firstImg.src = firstImg.dataset.src;
    firstImg.removeAttribute('data-src');
  }

  if (firstImg) {
    (firstImg.decode
      ? firstImg.decode()
      : new Promise(r => (firstImg.onload = r))
    ).finally(() => {
      const swiper = document.querySelector('.comicSwiper');
      swiper?.classList.remove('is-loading');
      swiper.style.minHeight = '';
    });
  } else {
    // fallback safety
    document.querySelector('.comicSwiper')?.classList.remove('is-loading');
    const swiper = document.querySelector('.comicSwiper');
    swiper?.classList.remove('is-loading');
    swiper.style.minHeight = '';
  }

  if ('IntersectionObserver' in window) {
    wrapper.querySelectorAll('img[data-src]').forEach(img => {
      imageObserver.observe(img);
    });
  } else {
    // fallback: load all immediately
    wrapper.querySelectorAll('img[data-src]').forEach(img => {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    });
  }
}

// load comic via manifest in each comic folder
async function loadComic(comicId) {
  try {
    // const swiperEl = document.querySelector('.comicSwiper');
    // swiperEl?.classList.add('is-loading');

    // if (swiperEl) {
    //   swiperEl.style.minHeight = `${swiperEl.offsetHeight}px`;
    // }

    const res = await fetch(`./img/comics/${comicId}/manifest.json`);
    if (!res.ok) throw new Error('Manifest not found');

    const manifest = await res.json();

    buildComicSwiper(comicId, manifest.totalPages);

    updateComicNav(manifest);
    updateSwitchNav(comicId);

    document
      .querySelectorAll('.books__grid__card')
      .forEach(c => c.classList.remove('books__is__current'));

    const activeCard = document
      .querySelector(`.books__grid__card a[href*="comic=${comicId}"]`)
      ?.closest('.books__grid__card');

    if (activeCard) {
      activeCard.classList.add('books__is__current');
      renderBooksPage(Number(activeCard.dataset.page || 1));
    }

    // ✅ SCROLL AFTER BUILD
    scrollToComicReader();

    // ✅ UPDATE SWIPE GIF
    toggleSwipeHint(manifest.totalPages);

    preloadNextComic(comicId);
  } catch (err) {
    console.error(err);
  }
}

// click handler
document.querySelectorAll('.books__grid__card a').forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault();

    const url = new URL(link.href, window.location.origin);
    const comicId = url.searchParams.get('comic');

    history.pushState({}, '', url);
    loadComic(comicId);
  });
});

// inital load
const activeComic = getComicFromURL();
if (activeComic) {
  loadComic(activeComic);
}

// // URL Helper
// function getComicFromURL() {
//   const params = new URLSearchParams(window.location.search);
//   return params.get('comic'); // "01", "02", etc
// }

// // scroll helper
// function scrollToComicReader() {
//   const reader = document.querySelector('.nav');
//   if (!reader) return;

//   const rect = reader.getBoundingClientRect();
//   if (rect.top > -50 && rect.top < 50) return;

//   window.scrollTo({
//     top: rect.top + window.pageYOffset - 16,
//     behavior: 'smooth',
//   });
// }

// // comic switching, area directly under the comics

// const FIRST_COMIC = 1;
// const LAST_COMIC = 11;

// function navigateComic(comicNumber) {
//   const comicId = String(comicNumber).padStart(2, '0');

//   history.pushState({}, '', `?comic=${comicId}`);
//   loadComic(comicId);
// }

// function updateSwitchNav(currentComicId) {
//   const nextBtn = document.querySelector('.switch__next');
//   const prevBtn = document.querySelector('.switch__prev');

//   if (!nextBtn || !prevBtn) return;

//   const current = Number(currentComicId);

//   const prevComic = current - 1;
//   const nextComic = current + 1;

//   // ---- PREV ----
//   if (current <= FIRST_COMIC) {
//     prevBtn.classList.add('is-disabled');
//     prevBtn.removeAttribute('href');
//   } else {
//     prevBtn.classList.remove('is-disabled');
//     prevBtn.href = `?comic=${String(prevComic).padStart(2, '0')}`;
//     prevBtn.onclick = e => {
//       e.preventDefault();
//       navigateComic(prevComic);
//     };
//   }

//   // ---- NEXT ----
//   if (current >= LAST_COMIC) {
//     nextBtn.classList.add('is-disabled');
//     nextBtn.removeAttribute('href');
//   } else {
//     nextBtn.classList.remove('is-disabled');
//     nextBtn.href = `?comic=${String(nextComic).padStart(2, '0')}`;
//     nextBtn.onclick = e => {
//       e.preventDefault();
//       navigateComic(nextComic);
//     };
//   }
// }

// // swipe hint
// function toggleSwipeHint(totalPages) {
//   const hint = document.getElementById('icon-swipe');
//   if (!hint) return;

//   if (totalPages < 3) {
//     hint.style.display = 'none';
//     hint.classList.remove('play');
//     hint.style.opacity = '1';
//     return;
//   }

//   // Show
//   hint.style.display = 'block';
//   hint.style.opacity = '1';

//   // Restart animation
//   hint.classList.remove('play');
//   void hint.offsetWidth; // force reflow
//   hint.classList.add('play');
// }

// // update nav text
// function updateComicNav(manifest) {
//   const chapterEl = document.querySelector('.nav__chapter');
//   if (!chapterEl) return;

//   if (manifest.title) {
//     chapterEl.textContent = manifest.title;
//   }
// }

// // Books List pager
// let booksPager = null;

// function renderBooksPage(page) {
//   if (!booksPager) return;

//   const { cards, pageButtons, prevBtn, nextBtn, totalPages } = booksPager;

//   booksPager.currentPage = Math.max(1, Math.min(totalPages, page));

//   cards.forEach(card => {
//     card.style.display =
//       Number(card.dataset.page) === booksPager.currentPage ? '' : 'none';
//   });

//   pageButtons.forEach(btn => {
//     btn.classList.toggle(
//       'books__page__active',
//       Number(btn.dataset.page) === booksPager.currentPage,
//     );
//   });

//   prevBtn.disabled = booksPager.currentPage <= 1;
//   nextBtn.disabled = booksPager.currentPage >= totalPages;
// }

// // book list initializaiton
// (() => {
//   const section = document.querySelector('.books');
//   if (!section) return;

//   const cards = Array.from(section.querySelectorAll('.books__grid__card'));
//   const pager = section.querySelector('.books__page');
//   if (!pager) return;

//   const pageButtons = Array.from(
//     pager.querySelectorAll('.books__page__btn.page'),
//   );
//   const prevBtn = pager.querySelector('.books__page__btn.prev');
//   const nextBtn = pager.querySelector('.books__page__btn.next');

//   booksPager = {
//     cards,
//     pageButtons,
//     prevBtn,
//     nextBtn,
//     totalPages: pageButtons.length,
//     currentPage: 1,
//   };

//   pageButtons.forEach(btn =>
//     btn.addEventListener('click', () =>
//       renderBooksPage(Number(btn.dataset.page)),
//     ),
//   );

//   prevBtn.addEventListener('click', () =>
//     renderBooksPage(booksPager.currentPage - 1),
//   );

//   nextBtn.addEventListener('click', () =>
//     renderBooksPage(booksPager.currentPage + 1),
//   );

//   renderBooksPage(1);
// })();

// // comic loading system

// let comicSwiper = null;

// // build swiper
// function buildComicSwiper(comicId, totalPages) {
//   const wrapper = document.querySelector('.comicSwiper .swiper-wrapper');
//   wrapper.innerHTML = '';

//   for (let i = 1; i <= totalPages; i++) {
//     const slide = document.createElement('div');
//     slide.className = `swiper-slide ${
//       i % 2 === 1 ? 'is-right-page' : 'is-left-page'
//     }`;

//     slide.innerHTML = `
//       <figure class="pageFigure swiper-zoom-container">
//         <img
//           class="pageImg singleComic"
//           src="./img/comics/${comicId}/${String(i).padStart(3, '0')}.webp"
//           alt="Page ${i}"
//           loading="lazy"
//         />
//       </figure>
//     `;

//     wrapper.appendChild(slide);
//   }

//   if (totalPages > 1 && totalPages % 2 === 1) {
//     wrapper.insertAdjacentHTML(
//       'beforeend',
//       `<div class="swiper-slide is-blank" aria-hidden="true">
//         <figure class="pageFigure"></figure>
//       </div>`,
//     );
//   }

//   if (comicSwiper) comicSwiper.destroy(true, true);

//   comicSwiper = new Swiper('.comicSwiper', {
//     loop: false,
//     watchOverflow: true,
//     dir: 'rtl',
//     slidesPerView: 2,
//     slidesPerGroup: 2,

//     breakpoints: {
//       0: {
//         slidesPerView: 1,
//         slidesPerGroup: 1,
//         centeredSlides: true,
//         zoom: { maxRatio: 3 },
//       },
//       1200: {
//         slidesPerView: 2,
//         slidesPerGroup: 2,
//         centeredSlides: false,
//         zoom: false,
//       },
//     },

//     navigation: {
//       nextEl: '.swiper-button-next',
//       prevEl: '.swiper-button-prev',
//     },

//     keyboard: { enabled: true },
//   });
// }

// // load comic via manifest in each comic folder
// async function loadComic(comicId) {
//   try {
//     const res = await fetch(`./img/comics/${comicId}/manifest.json`);
//     if (!res.ok) throw new Error('Manifest not found');

//     const manifest = await res.json();

//     buildComicSwiper(comicId, manifest.totalPages);

//     updateComicNav(manifest);
//     updateSwitchNav(comicId);

//     document
//       .querySelectorAll('.books__grid__card')
//       .forEach(c => c.classList.remove('books__is__current'));

//     const activeCard = document
//       .querySelector(`.books__grid__card a[href*="comic=${comicId}"]`)
//       ?.closest('.books__grid__card');

//     if (activeCard) {
//       activeCard.classList.add('books__is__current');
//       renderBooksPage(Number(activeCard.dataset.page || 1));
//     }
//     // ✅ SCROLL AFTER BUILD
//     scrollToComicReader();

//     // ✅ UPDATE SWIPE GIF
//     toggleSwipeHint(manifest.totalPages);
//   } catch (err) {
//     console.error(err);
//   }
// }

// // click handler
// document.querySelectorAll('.books__grid__card a').forEach(link => {
//   link.addEventListener('click', e => {
//     e.preventDefault();

//     const url = new URL(link.href, window.location.origin);
//     const comicId = url.searchParams.get('comic');

//     history.pushState({}, '', url);
//     loadComic(comicId);
//   });
// });

// // inital load
// const activeComic = getComicFromURL();
// if (activeComic) {
//   loadComic(activeComic);
// }
